import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import StyledHeader from '@r1-frontend/ui-react/organisms/Card/CardBricks/StyledHeader';

import { TTVSetTopSelectableProps } from './TVSetTopSelectable';

const DesktopTVSetTopSelectableCard = ({
    group,
    title,
    description,
}: Omit<TTVSetTopSelectableProps, 'images'>): JSX.Element => {
    return (
            <ListContainer $size={24} $direction={'column'}>
                <StyledHeader group={group} title={title} description={description} />
            </ListContainer>
    );
};

export default DesktopTVSetTopSelectableCard;
